import { render, staticRenderFns } from "./SmartShelf.vue?vue&type=template&id=7d4222e6&"
import script from "./SmartShelf.vue?vue&type=script&lang=js&"
export * from "./SmartShelf.vue?vue&type=script&lang=js&"
import style0 from "./SmartShelf.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports